module.exports = __webpack_public_path__ + "static/media/jerseytex-full.d5f6fc17.png";